var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"c-trial-line",attrs:{"href":"#"},on:{"click":_vm.onClick}},[_c('div',{staticClass:"c-trial-line__info"},[_vm._v("Trial period. "+_vm._s(_vm.trialStartedDifference)+" left.")])])}
var staticRenderFns = []

export { render, staticRenderFns }